import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartPresetId } from '@cli-types/preset-engine/presets.js'
import { normalizeInstalledPresets } from './normalize-installed-presets.js'

export function getInstalledPresets(config: ResolvedBetterstartConfig): BetterstartPresetId[] {
  return normalizeInstalledPresets(config)
}
